module.exports = __webpack_public_path__ + "static/media/antenas_rfs.350bd705.jpg";